<template>
  <div v-if="game">
    <div class="board">
      <div v-for="(row, rowc) in visibleBoard" v-bind:key="rowc" class="board-row">
        <div class="board-col" :ref="`${rowc}_${colc}`" v-bind:key="`${rowc}_${colc}`" v-bind:class="{ 'base': isBase(rowc, colc), 'playable': isPlayable(rowc, colc), 'askedFor': game.askedFor === `${rowc}_${colc}`, 'lastPlayed': game.lastPlayed.indexOf(`${rowc}_${colc}`) > -1, 'lastCaptured': game.lastCaptured.indexOf(`${rowc}_${colc}`) > -1 }" v-for="(col, colc) in row" @click.prevent="handleClick(rowc, colc)">
          <div class="board-piece" :ref="`${rowc}_${colc}_piece`" v-bind:class="col" v-if="col !== ' '"></div>
          <!-- <transition v-on:before-enter="beforeEnter" name="fade">
          </transition> -->
          <div v-if="rowc == game.n - 1" class="col-count">{{ game.chars.charAt(colc) }}</div>
        </div>
        <div class="row-count">{{ game.n - rowc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'tafl',
  computed: {
    ...mapState({
      game: state => state.game.currentGame,
    }),
    ...mapGetters(['isLoggedIn', 'getCurrentUser', 'getUserData']),
    visibleBoard() {
      return this.game.board;
      // @TODO: fix after boardHistory is active
      // if (this.clientSideData.moveIndex === -1) {
      //   return this.game.board;
      // }
      // return this.game.boardHistory[this.clientSideData.moveIndex];
    },
  },
  props: ['config', 'clientSideData'],
  created() {
    this.$store.dispatch('createGame', this.config);
  },
  destroyed() {
    this.$store.dispatch('endGame');
  },
  methods: {
    isPlayable(row, col) {
      return this.game.isPlayable(row, col);
    },
    isBase(row, col) {
      return this.game.isBase(row, col);
    },
    mySide() {
      return this.game.playerInfo.find(pi => pi.player === this.getCurrentUser.uid).side;
    },
    handleClick(row, col) {
      if (this.game.finished) {
        return;
      }
      if (this.mySide() !== this.game.getTurnPlayerSide()) {
        return;
      }
      const index = this.game.playableSquares.indexOf(`${row}_${col}`);

      if (index === -1) {
        this.game.setPlayableSquares(row, col);
      } else {
        const from = this.game.constructor.getNumValues(this.game.askedFor);
        const to = [row, col];

        // this is for animation
        // if (from[0] === to[0]) {
        //   this.setBeforeEnterCoords(from, to, 'col');
        // } else {
        //   this.setBeforeEnterCoords(from, to, 'row');
        // }

        // this.game.move(from, to);
        this.$root.$emit('move', { from, to });
        // this.game.altMove(from, to);
        // setTimeout(() => {
        //   // this.animate(to);
        // }, 0);
      }
    },
    // setBeforeEnterCoords(from, to, colOrRow) {
    //   let diff = 0;
    //   if (colOrRow === 'col') {
    //     diff = to[1] - from[1];
    //     this.coords = { top: '10px', left: `${-50 * diff}px` };
    //   } else {
    //     diff = to[0] - from[0];
    //     this.coords = { top: `${-50 * diff}px`, left: 0 };
    //   }
    // },
    // animate(to) {
    //   this.$refs[`${to[0]}_${to[1]}_piece`][0].velocity({ left: 0, top: 10 }, 140, 'ease-in-out');
    // },
    // beforeEnter(el) {
    //   el.style.top = this.coords.top;
    //   el.style.left = this.coords.left;
    // },
  },
  data() {
    return {
      coords: {},
    };
  },
};
</script>

<style scoped lang="scss">
  @mixin board($w) {
    .board-row {
      width: $w * 11;
      display: block;
      position: relative;
      height: $w;
      .row-count, .col-count {
        display: block;
        position: absolute;
        line-height: $w;
        font-size: 11px;
        font-weight: bold;
        right: -$w * .5;
        text-align: center;
        width: $w * .5;
      }
      .col-count { width: $w; top: $w * .7; left: 0; }
    }
    .board-col {
      position: relative;
      display: block;
      float: left;
      background: rgba(255,255,255, 0.5);
      border: $w * 0.015 solid rgba(0,0,0,0.1);
      cursor: pointer;
      // box-shadow: 0 0 5px 0px rgba(0,0,0,0.05);
      // box-shadow: 0 0 5px 0px rgba(0,0,0,0.1);
      width: $w;
      height: $w;

      &:hover {
        cursor: pointer;
        background: rgba(0,0,0,0.1);
      }
      &.base {
        &:hover {
          background: rgba(210,90,10,0.4);
        }
        background: rgba(210,90,10,0.3);
      }
      &.askedFor {
        background: rgba(40,167,69,0.6);
      }

      &.lastPlayed {
        background: rgba(155,199,0,0.41)
      }

      &.lastCaptured {
        background: rgba(255, 215, 0, .35)
      }

      &.playable:hover {
        background: rgba(40,167,69,0.6);
        &:after {
          display: none;
        }
      }
      &.playable:after {
        content: "";
        display: block;
        position: relative;
        width: $w * .32;
        height: $w * .32;
        line-height: $w;
        margin: 0 auto;
        top: $w * .34;
        border-radius: $w;
        background: rgba(40,167,69,0.6);
      }
    }
    .board-piece {
      display: block;
      width: $w * 0.6;
      height: $w * 0.6;
      margin: 0 auto;
      top: $w * 0.2;
      border: $w * .04 solid #222;
      border-radius: 5px;
      position: relative;
      cursor: pointer;
      z-index: 2;
      &.a {
        background: #111;
      }
      &.d {
        background: #fff;
      }
      &.k {
        $symbol: $w * .24;
        &:after {
          content: "";
          display: block;
          position: absolute;
          border-radius: 2px;
          width: $symbol;
          height: $symbol;
          background: #111;
          left: (($w * 0.6) - ($symbol * 1.3))/2;
          top: (($w * 0.6) - ($symbol * 1.3))/2;
          transform: rotate(45deg);
        }
      }
    }
  }

  $w: 3.578vw;
  @include board($w);

  @media (max-width: 1791.98px) {
    // $w: 60.12px;
    // @include board($w);
  }

  @media (max-width: 991.98px) {
    $w: 8vw;
    @include board($w);
  }

  .fade-leave-active {
    transition: all .14s;
  }
  .fade-leave-to {
    opacity: 0;
    transform: scale(0.2);
  }
</style>
